// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button__Button__QI7b2","first-of-type":"Button__first-of-type__1hEnB","Success":"Button__Success__2dHUt","Danger":"Button__Danger__2xnhN"};